module.exports = __webpack_public_path__ + "static/media/ExamWarning.c5dbea08.svg";